<template>
  <div class="mobileFriends botPage">
    <mbHeader :title="$t('inviteFriends')" :left="true" :lang="true"></mbHeader>
    <inviteFriends></inviteFriends>
  </div>
</template>

<script>
import mbHeader from "../../components/mobile/mbHeader";
import inviteFriends from "../Profile/inviteFriends";

export default {
  name: "mobileFriends",
  components: {mbHeader, inviteFriends},
}
</script>

<style scoped lang="less">
.mobileFriends{
  min-height: 100vh;
  padding: 66px 16px 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileFriends.vue